
/* injects from baggage-loader */

'use strict';

import confirmedTemplate from '!!file-loader?name=templates/[name].[ext]!./confirmed.html';

/**
 * Function that register the all routes for the confirmed components module.
 *
 * @param {any} $q
 * @param {any} $ocLazyLoad
 * @param {any} routerHelper
 */
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	 * Route definition of the management confirmed component page.
	 */
	const indexNav = 6;
	const indexSubmenu = 0;
	const confirmedRoute = {
		state: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].URL,
			templateUrl: confirmedTemplate,
			controller: 'ConfirmedController',
			controllerAs: 'confirmedvm',
			resolve: {
				confirmed: confirmedLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].NAME,
				submenu: true,
			},
		}
	};

	routerHelper.configureStates([confirmedRoute]);
}

/**
 * Function for the lazyLoading configuration in the confirmed components route.
 *
 * @param {any} $q
 * @param {any} $ocLazyLoad
 * @returns
 */
function confirmedLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const confirmedModule = require('./confirmed.module.js');

		$ocLazyLoad.load({
			name: confirmedModule.default.name,
		});

		deferred.resolve(confirmedModule.default.controller);
	});

	return deferred.promise;
}

export default angular
	.module('confirmed.routes', [])
	.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/components/confirmed/confirmed.routes.js